/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Scenario } from '../models/Scenario';
import type { ScenarioValuesCalculation } from '../models/ScenarioValuesCalculation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AllocationScenarioService {
    /**
     * @param data
     * @returns Scenario
     * @throws ApiError
     */
    public static apiAllocationScenarioAllocationResultsCreate(
        data: ScenarioValuesCalculation,
    ): CancelablePromise<Scenario> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/allocation-scenario/allocation-results',
            body: data,
        });
    }
}
